export function languageFromPath(pathname) {
  return pathname === "/es" || pathname.startsWith("/es/") ? "es" : "en";
}

export function pathForLanguage(target, language) {
  if (!target || !target.startsWith("/") || target.startsWith("//")) return target;

  const suffixIndex = target.search(/[?#]/);
  const pathname = suffixIndex === -1 ? target : target.slice(0, suffixIndex);
  const suffix = suffixIndex === -1 ? "" : target.slice(suffixIndex);
  const unlocalized = pathname.replace(/^\/es(?=\/|$)/, "") || "/";
  const localized = language === "es" ? (unlocalized === "/" ? "/es" : `/es${unlocalized}`) : unlocalized;

  return `${localized}${suffix}`;
}
